import FormControl from "@material-ui/core/FormControl";
import InputAdornment from "@material-ui/core/InputAdornment";
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import AssessmentIcon from "@material-ui/icons/Assessment";
import DirectionsCarIcon from "@material-ui/icons/DirectionsCar";
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem.jsx";
import TablePagination from "components/TablePagination/TablePagination.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Alerta2Botones from "conten/components/Alerta2Botones";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";

import {
  formatDate,
  formatDateTimeReporte,
  formatNumberDate,
  formatoDinero,
  getHorasMinutosTranscurridos,
} from "config/funciones/Comunes";
import {
  CONFIGURACION_TIPOGRAFIA_14,
  FILA_BLANCA,
  FILA_GRIS,
  OK,
} from "config/general/Configuracion";

import TituloPagina2 from "conten/components/TituloPagina2";
import WaitDialog from "conten/components/WaitDialog.jsx";
import { informeVehiculo, hacerPagoExtemporaneoWEB } from "conten/informes/InformesActions";
import { listarUsuario } from "conten/usuarios/UsuarioActions";
import React from "react";
import { connect } from "react-redux";
import { InputLabel, Select } from "@material-ui/core";
import PlacaApi from '../mensualidades/Placas/PlacasApiClient';
import { LISTADO_PAGINACION } from "config/general/Configuracion";
import "assets/scss/components/informeVehiculo.scss";

const ESTADO_REPORTADO = 3;
const PAGO_EXTEMPORANEO = 4;

class InformeHistorico extends React.Component {
  constructor(props) {
    super(props);
    const fechaActual = formatDate(new Date(Date.now()), "yyyy-mm-dd");
    this.state = {
      contenidoAlerta: null,
      textAlertInfo: "Un momento mientras completamos su solicitud ;)",
      fechaActual: fechaActual,
      datosConsulta: {
        nfInicial: formatNumberDate(fechaActual),
        nfFinal: formatNumberDate(fechaActual),
        placa: "",
        paginacion: {
          limite: LISTADO_PAGINACION[0],
          actual: 1,
          filtro: null,
          orden: null,
          sentido: null,
        },
      },
      reporte: [],
      listaPlacas: [],
    };
  }

  componentWillUnmount() { }

  componentDidMount = () => {
    this.traerDatosServidor();
    this.obtenerPlacas();
  };

  cambioFechaInicial = (evento) => {
    var datosConsulta = this.state.datosConsulta;
    datosConsulta.nfInicial = formatNumberDate(evento.target.value);
    this.setState({ datosConsulta: datosConsulta }, this.recuperarReporte);
  };

  cambioFechaFinal = (evento) => {
    var datosConsulta = this.state.datosConsulta;
    datosConsulta.nfFinal = formatNumberDate(evento.target.value);
    this.setState({ datosConsulta: datosConsulta }, this.recuperarReporte);
  };

  cambioContenidoPlaca = (valor) => {
    var datosConsulta = this.state.datosConsulta;
    datosConsulta.placa = (valor + "").trim().toUpperCase();
    this.setState({ datosConsulta: datosConsulta }, this.recuperarReporte);
  };

  traerDatosServidor = () => {
    this.recuperarReporte();
  };

  recuperarReporte = () => {
    var placa = this.state.datosConsulta.placa;
    if (placa.trim().length < 5) {
      return;
    }
    this.props.informeVehiculo(
      this.state.datosConsulta,
      this.respuestaInformeVehiculo
    );
  };

  emojiIcon = (emoji) => () => (
    <div
      style={{
        fontSize: '20px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 20,
        height: 20,
        lineHeight: 1,
      }}
    >
      {emoji}
    </div>
  );

  obtenerPlacas = () => {
    const paginacion = {
      limite: 50,
      actual: 1,
      filtro: null,
      orden: "placa",
      sentido: "ASC",
    };
    PlacaApi.listarPlacas(paginacion).then((respuesta) => {
      if (respuesta && respuesta.data && Array.isArray(respuesta.data.placas)) {
        this.setState({ listaPlacas: respuesta.data.placas });
      } else {
        this.setState({ listaPlacas: [] });
      }

    }).catch((error) => {
      console.error("Error al obtener placas", error);
      this.setState({ listaPlacas: [] });
    });
  };

  respuestaInformeVehiculo = (estado, contenido) => {
    if (estado !== OK) {
      return;
    }
    var datosConsulta = this.state.datosConsulta;
    datosConsulta.paginacion = contenido.paginacion;
    this.setState({ reporte: contenido.reporte, datosConsulta });
  };

  cambioContenidoPromotor = (idPromotor) => {
    var datosConsulta = this.state.datosConsulta;
    datosConsulta.promotor = idPromotor;
    this.setState({ datosConsulta }, this.recuperarReporte);
  };

  funcionEnBlanco = () => { };

  respuestaProcesarPagoExtemporaneo = (estado, respuesta) => {
    this.traerDatosServidor();
  }

  continuarCerrarProcesarPagoExtemporaneo = (contenido) => {
    this.cerrarProcesarPagoExtemporaneo();
    var localContenido = {
      idPago: contenido.id,
      placa: contenido.placa
    }
    this.props.hacerPagoExtemporaneoWEB(
      localContenido,
      this.respuestaProcesarPagoExtemporaneo
    );
  };

  cerrarProcesarPagoExtemporaneo = () => {
    this.setState({ contenidoAlerta: null });
  };

  cancelarCerrarProcesarPagoExtemporaneo = () => {
    this.cerrarProcesarPagoExtemporaneo();
  };

  // procesarPagoExtemporaneo = (contenido) => {
  //   var contenidoAlerta = (
  //     <Alerta2Botones
  //       key="preguntarProcesarPagoExtemporaneo"
  //       titulo="Registrar pago"
  //       mensaje={"¿Desea realizar el pago extemporaneo?"}
  //       contenido={contenido}
  //       textoBotonAceptar="Aceptar"
  //       textoBotonCancelar="Cancelar"
  //       eventoBotonAceptar={this.continuarCerrarProcesarPagoExtemporaneo}
  //       eventoBotonCancelar={this.cancelarCerrarProcesarPagoExtemporaneo}
  //       iconoAceptar={<CheckCircleIcon />}
  //       iconoCancelar={<CancelIcon />}
  //     />
  //   );
  //   this.setState({ contenidoAlerta: contenidoAlerta });
  // };

  procesarPagoExtemporaneo = (contenido) => {
    const mensaje = (
      <>
        Esta funcionalidad aún se encuentra en desarrollo.
        <br />
        Si necesitas registrar un pago extemporáneo, por favor comunícate con nosotros vía WhatsApp al número <strong>+57 310 221 1374</strong>.
      </>
    );

    const contenidoAlerta = (
      <Alerta2Botones
        key="preguntarProcesarPagoExtemporaneo"
        titulo="Funcionalidad en desarrollo"
        mensaje={mensaje}
        contenido={contenido}
        textoBotonAceptar="Abrir WhatsApp"
        textoBotonCancelar="Cancelar"
        eventoBotonAceptar={() => {
          window.open("https://wa.me/573102211374?text=Hola%2C%20necesito%20registrar%20un%20pago%20extempor%C3%A1neo.", "_blank");
          this.setState({ contenidoAlerta: null });
        }}
        eventoBotonCancelar={() => this.setState({ contenidoAlerta: null })}
        iconoAceptar={<CheckCircleIcon />}
        iconoCancelar={<CancelIcon />}
      />
    );

    this.setState({ contenidoAlerta });
  };


  renderFila = (pregunta) => {
    var res = [];
    pregunta.map((contenido, index) => {
      var colorFila = index % 2 == 0 ? FILA_BLANCA : FILA_GRIS;
      res.push(
        <>
          <GridItem
            xs={12}
            sm={12}
            md={2}
            lg={2}
            style={{ backgroundColor: colorFila }}
          >
            {contenido.cumple}
          </GridItem>
          <GridItem
            xs={12}
            sm={12}
            md={7}
            lg={7}
            style={{ backgroundColor: colorFila }}
          >
            {contenido.contenido}
          </GridItem>
          <GridItem
            xs={12}
            sm={12}
            md={3}
            lg={3}
            style={{ backgroundColor: colorFila }}
          >
            {contenido.valor === "" ? "--" : contenido.valor}
          </GridItem>
        </>
      );
    });
    return res;
  };

  getNombresReferenicasXLS = () => {
    var encabezado = [];
    encabezado.push({ title: "Estado", dataIndex: "estado" });
    encabezado.push({ title: "Placa", dataIndex: "placa" });
    encabezado.push({ title: "Vehículo", dataIndex: "vehiculo" });
    encabezado.push({ title: "Id cobro", dataIndex: "idcobro" });
    encabezado.push({ title: "Zona", dataIndex: "zona" });
    encabezado.push({ title: "Zona inicia", dataIndex: "zonainicia" });
    encabezado.push({ title: "Zona termina", dataIndex: "zonatermina" });
    encabezado.push({ title: "Zona valor hora", dataIndex: "zonavalor" });
    encabezado.push({ title: "Zona minutos gracia", dataIndex: "zonamin" });
    encabezado.push({
      title: "Zona minutos para nueva gracia",
      dataIndex: "zonaminnueva",
    });
    encabezado.push({ title: "Fecha hora ingreso", dataIndex: "feingreso" });
    encabezado.push({ title: "Promotor ingreso", dataIndex: "proingreso" });
    encabezado.push({ title: "Fecha hora egreso", dataIndex: "feegreso" });
    encabezado.push({ title: "Promotor egreso", dataIndex: "proegreso" });
    encabezado.push({ title: "Horas cobradas", dataIndex: "hcobradas" });
    encabezado.push({ title: "valor cobrado", dataIndex: "vcobrado" });
    encabezado.push({ title: "Fecha hora recaudo", dataIndex: "ferecaudo" });
    encabezado.push({ title: "Promotor recauda", dataIndex: "prorecaudo" });
    encabezado.push({ title: "Promotor  reporta", dataIndex: "proreporte" });
    return encabezado;
  };

  getContenidosXLS = (contenido) => {
    var resul = [];
    contenido.map((reg) => {
      var cont = {};
      cont["estado"] = reg.nombre_estado;
      cont["placa"] = reg.placa;
      cont["vehiculo"] = reg.es_carro === true ? "Carro" : "Moto";
      cont["idcobro"] = reg.id + "";
      cont["zona"] = reg.nombre_zona;
      cont["zonainicia"] = reg.h_inicia_zona;
      cont["zonatermina"] = reg.h_termina_zona;
      cont["zonavalor"] = reg.valor_h;
      cont["zonamin"] = reg.minutos_gracia_zona;
      cont["zonaminnueva"] = reg.minutos_para_nueva_gracia_zona;
      cont["feingreso"] = formatDateTimeReporte(reg.fh_ingreso);
      cont["proingreso"] = reg.nombre_promotor_ingreso;
      cont["feegreso"] = formatDateTimeReporte(reg.fh_egreso);
      cont["proegreso"] = reg.nombre_promotor_egreso;
      cont["hcobradas"] = reg.h_cobradas;
      cont["vcobrado"] = reg.valor_cobrado;
      cont["ferecaudo"] = formatDateTimeReporte(reg.fh_recaudo);
      cont["prorecaudo"] = reg.nombre_promotor_recauda;
      cont["proreporte"] = reg.nombre_promotor_reporta;
      resul.push(cont);
    });

    return resul;
  };

  cambioPagina = (page) => {
    var datosConsulta = this.state.datosConsulta;
    datosConsulta.paginacion.actual = page;
    this.setState({ datosConsulta: datosConsulta }, () => {
      this.traerDatosServidor();
    });
  };

  cambioLimite = (numFilas) => {
    var datosConsulta = this.state.datosConsulta;
    datosConsulta.paginacion.limite = numFilas;
    this.setState({ datosConsulta: datosConsulta }, () => {
      this.cambioPagina(1);
    });
  };

  render() {
    const { classes } = this.props;
    const { paginacion } = this.state.datosConsulta;
    const { isActivityIndicatorShown } = this.props.informesState;
    var reporte = this.state.reporte;
    return (
      <GridItem xs={12}>
        {isActivityIndicatorShown && (
          <WaitDialog text={this.state.textAlertInfo} />
        )}
        {this.state.contenidoAlerta}
        <Card style={{ marginTop: '45px' }}>
          <CardHeader icon>
            <CardIcon color="primary"
              style={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '50px',
                width: '50px'
              }}>
              {this.emojiIcon('📋')()}
            </CardIcon>
            <TituloPagina2
              texto="Historial de vehículo"
              color="primary"
              classes={classes}
              style={{ height: "30px", display: "block", lineHeight: "30px" }}
            />
          </CardHeader>
          <CardBody>
            <GridContainer
              key={"GridContainer-parametros"}
              container
              alignItems="center"
            >
              <GridItem xs={12} sm={12} md={3} lg={3}>
                <FormControl fullWidth>
                  <TextField
                    id="fechaInicial"
                    label="Fecha inicial"
                    type="date"
                    defaultValue={
                      this.state.fechaActual
                      /*formatDate(
                      new Date(2020, 1, 1),
                      "yyyy-mm-dd")*/
                    }
                    className={classes.textField}
                    onChange={this.cambioFechaInicial}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </FormControl>
              </GridItem>
              <GridItem xs={12} sm={12} md={3} lg={3}>
                <FormControl fullWidth>
                  <TextField
                    id="fechaFinal"
                    label="Fecha final"
                    type="date"
                    defaultValue={this.state.fechaActual}
                    className={classes.textField}
                    onChange={this.cambioFechaFinal}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </FormControl>
              </GridItem>
              <GridItem xs={12} sm={12} md={3} lg={3}>
                <FormControl fullWidth>
                  <InputLabel htmlFor="placa">Placa</InputLabel>
                  <Select
                    native
                    id="placa"
                    value={this.state.datosConsulta.placa}
                    onChange={(event) => this.cambioContenidoPlaca(event.target.value)}
                    startAdornment={
                      <InputAdornment position="start">
                        <DirectionsCarIcon />
                      </InputAdornment>
                    }
                  >
                    <option value="">Selecciona una placa</option>
                    {(this.state.listaPlacas || []).map((item) => (
                      <option key={item.id} value={item.placa}>
                        {item.placa}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </GridItem>
            </GridContainer>
            <GridContainer
              key={"GridContainer-encabezado"}
              container
              alignItems="center"
              style={CONFIGURACION_TIPOGRAFIA_14}
            >

            </GridContainer>
            {reporte.map((registro, index) => {
              return (
                <GridContainer
                  key={"GridContainer-" + index}
                  container
                  alignItems="center"
                  className="gridRow-list-vehicle-report"
                  style={Object.assign(
                    {
                      backgroundColor: index % 2 == 0 ? FILA_BLANCA : FILA_GRIS,
                      marginTop: "2px",
                      padding: "7px",

                    },
                    CONFIGURACION_TIPOGRAFIA_14
                  )}
                >
                  <GridItem xs={12} sm={12} md={2} lg={2}>
                    <h5 style={{ fontWeight: 'bold' }}>{registro.nombre_estado}</h5>
                    <div>
                      {registro.estado === ESTADO_REPORTADO && <Button
                        key={"button-pago-extemporaneo" + index}
                        type="button"
                        //disabled={true}
                        onClick={(e) => {
                          this.procesarPagoExtemporaneo(registro);
                          e.preventDefault();
                        }}
                        color="success"
                      >
                        <MonetizationOnIcon />
                        Pagar
                      </Button>}
                    </div>
                    <div>
                      {registro.estado === PAGO_EXTEMPORANEO && registro.promotor_recauda === null ? "Pago WEB" : ""}
                    </div>

                  </GridItem>

                  <GridItem xs={12} sm={12} md={5} lg={5}>
                    <div>
                      <b>{"Hora ingreso: "}</b>
                      {formatDateTimeReporte(registro.fh_ingreso)}
                    </div>
                    <div>
                      <b>{"Promotor ingreso: "}</b>
                      {registro.nombre_promotor_ingreso}
                    </div>
                    <div>
                      <b>{"Zona: "}</b>
                      {registro.nombre_zona}
                    </div>
                    <div>
                      <b>{"Valor hora: "}</b>
                      {formatoDinero(registro.valor_h)}
                    </div>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={5} lg={5}>
                    <div>
                      <b>{"Hora salida: "}</b>
                      {formatDateTimeReporte(registro.fh_egreso)}
                    </div>
                    <div>
                      <b>{"Tiempo: "}</b>
                      {getHorasMinutosTranscurridos(registro.fh_ingreso, registro.fh_egreso)}
                    </div>
                    <div>
                      <b>{"Horas cobradas: "}</b>
                      {registro.h_cobradas +
                        (registro.h_cobradas === 1 ? " hora" : " horas")}
                    </div>
                    <div>
                      <b>{"Valor cobrado: "}</b>
                      {formatoDinero(registro.valor_cobrado)}
                    </div>
                    <div>
                      <b>{"Promotor salida: "}</b>
                      {registro.nombre_promotor_egreso === null
                        ? "Sistema"
                        : registro.nombre_promotor_egreso}
                    </div>
                  </GridItem>
                </GridContainer>
              );
            })}
            {paginacion && (
              <TablePagination
                color="success"
                rowsPerPageOptions={LISTADO_PAGINACION}
                pages={Math.ceil(paginacion.total / paginacion.limite)}
                rowsPerPage={paginacion.limite}
                page={paginacion.actual}
                onChangePage={this.cambioPagina}
                onChangeRowsPerPage={this.cambioLimite}
              />
            )}
          </CardBody>
        </Card>
      </GridItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuarioState: state.usuarioState,
    informesState: state.informesState,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {

    hacerPagoExtemporaneoWEB: (contenido, onSuccess) =>
      dispatch(hacerPagoExtemporaneoWEB(contenido, onSuccess)),

    listarUsuario: (paginacion) =>
      dispatch(listarUsuario(paginacion, () => { })),

    informeVehiculo: (parametros, onSuccess) =>
      dispatch(informeVehiculo(parametros, onSuccess)),
  };
};

export default withStyles(extendedTablesStyle)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(InformeHistorico)
);
